module.exports = __webpack_public_path__ + "img/expoglitter_0915_silver.f1c996fe.jpg";